// Safe localStorage — iOS Safari throws on access in private mode / when storage is blocked,
// which would crash any component that reads it during render. Never throw.
export const ls = {
  get(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* ignore */
    }
  },
};
